import React from 'react';

export const Footer = (props) => {
    return (
        <section className="wrapper-footer">
            <footer className="footer">
                <img className="hero-profile" src={`${process.env.PUBLIC_URL}/assets/perfil.png`} alt="Selgi Obregon" />
                <div className="border-top"></div>
                <h2 className="footer__quote">
                    "En tus Manos y en tu Corazón tienes el arte para crear"
                </h2>
                <p className="footer__address">
                    Miami Florida, 16885 sw 90 terrace Miami fl 33196 | 7862853182 | <a href="mainto:selgiobregon19@gmail.com">selgiobregon19@gmail.com</a>
                </p>
                <section className="footer__social">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                        <img className="social-icon" src={`${process.env.PUBLIC_URL}/assets/fb.png`} alt="Facebook: Selgi Obregon" />
                    </a>
                    <a href="#" target="_blank" rel="noopener noreferrer">
                        <img className="social-icon" src={`${process.env.PUBLIC_URL}/assets/in.png`} alt="Instagram: Selgi Obregon" />
                    </a>
                </section>
            </footer>
        </section>
    );
};